export default function ConfigureCharger() {
  // TODO: create configure charger device page
  return <></>
}
